/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ZoomInputs */

const en_zoom = /** @type {(inputs: ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoom...`)
};

const fr_zoom = /** @type {(inputs: ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoom...`)
};

const de_zoom = /** @type {(inputs: ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoom...`)
};

const it_zoom = /** @type {(inputs: ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoom...`)
};

const ru_zoom = /** @type {(inputs: ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Приблизить...`)
};

const es_zoom = /** @type {(inputs: ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoom...`)
};

const zh_cn2_zoom = /** @type {(inputs: ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`飞涨...`)
};

const ja_zoom = /** @type {(inputs: ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ズーム...`)
};

const hi_zoom = /** @type {(inputs: ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ज़ूम...`)
};

const pt_pt2_zoom = /** @type {(inputs: ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoom...`)
};

/**
* | output |
* | --- |
* | "Zoom..." |
*
* @param {ZoomInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const zoom = /** @type {((inputs?: ZoomInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ZoomInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_zoom(inputs)
	if (locale === "de") return de_zoom(inputs)
	if (locale === "it") return it_zoom(inputs)
	if (locale === "ru") return ru_zoom(inputs)
	if (locale === "es") return es_zoom(inputs)
	if (locale === "zh-CN") return zh_cn2_zoom(inputs)
	if (locale === "ja") return ja_zoom(inputs)
	if (locale === "hi") return hi_zoom(inputs)
	if (locale === "pt-PT") return pt_pt2_zoom(inputs)
	return en_zoom(inputs)
});